import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function WishlistHighlight({ wishlistNumber }) {
  return (
    <Link to="/account/wishlist">
      <div className="account-highlight-card wishlist-design">
        <div className="highlight-title">
          <FormattedMessage id="wishlist-highlight.title" defaultMessage="Wishlist" />
        </div>
        <div className="card-line" />
        <div className="icon-number-container">
          <div className="icon-container">
            <FontAwesomeIcon icon={faHeart} />
          </div>
          <div className="number-container">
            {wishlistNumber}
          </div>
        </div>
        <div className="card-line" />
        <div className="view-button">
          <FormattedMessage id="wishlist-highlight.button.text" defaultMessage="View Wishlist" />
        </div>
      </div>
    </Link>
  );
}

WishlistHighlight.propTypes = {
  wishlistNumber: PropTypes.number,
};

WishlistHighlight.defaultProps = {
  wishlistNumber: 0,
};
